import { groupModel } from 'APP/model/model';

export async function addParticipants(
  groupId: string,
  userIds: string[]
): Promise<{ error: string | null }> {
  try {
    await groupModel.addGroupParticipants({ groupId, userIds });

    return { error: null };
  } catch (error) {
    return { error: error.message };
  }
}
